import { render, staticRenderFns } from "./AddToSharedFolder.vue?vue&type=template&id=3b88069b&scoped=true"
import script from "./AddToSharedFolder.vue?vue&type=script&lang=ts"
export * from "./AddToSharedFolder.vue?vue&type=script&lang=ts"
import style0 from "./AddToSharedFolder.vue?vue&type=style&index=0&id=3b88069b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b88069b",
  null
  
)

export default component.exports